// extracted by mini-css-extract-plugin
module.exports = {"Panel":"styles_Panel__15yDp"};